import {TemplateField} from '../../core/definitions/template-field';

export interface TemplateFieldRow {
  id: string;
  field: TemplateField;
  isGroup: boolean;
  expanded: boolean;
  parentGroupId?: string;
}

export function buildTemplateFieldRows(fields: TemplateField[], query: string,
                                       expandedGroupIds: Set<string>): TemplateFieldRow[] {
  const normalizedQuery = query.trim().toLowerCase();
  const isShown = (candidate: TemplateField) =>
    candidate.field_title.toLowerCase().includes(normalizedQuery);
  const rows: TemplateFieldRow[] = [];
  for (const candidate of [...fields].sort(compareFirstWordOfTitle)) {
    if (candidate.children.length) {
      rows.push(...groupRows(candidate, candidate.children.filter(isShown),
        !!normalizedQuery || expandedGroupIds.has(templateFieldGroupId(candidate))));
    } else if (isShown(candidate)) {
      rows.push(fieldRow(candidate));
    }
  }
  return rows;
}

export function conditionSourceValue(fieldSourceId: string | null, columnSourceId: string | null,
                                     modelTypeId: string): string | null {
  if (fieldSourceId) {
    return fieldSourceId === columnSourceId ? null : fieldSourceId;
  }
  return columnSourceId && columnSourceId !== modelTypeId ? modelTypeId : null;
}

function templateFieldGroupId(field: TemplateField): string {
  return field.superobject_type_id || field.artifact_id;
}

function compareFirstWordOfTitle(left: TemplateField, right: TemplateField): number {
  const leftKey = left.field_title.split(' ')[0].toLowerCase();
  const rightKey = right.field_title.split(' ')[0].toLowerCase();
  return leftKey < rightKey ? -1 : leftKey > rightKey ? 1 : 0;
}

function groupRows(group: TemplateField, children: TemplateField[], expanded: boolean): TemplateFieldRow[] {
  if (!children.length) {
    return [];
  }
  const id = `group-${templateFieldGroupId(group)}`;
  const header: TemplateFieldRow = {id, field: group, isGroup: true, expanded};
  return expanded ? [header, ...children.map(child => fieldRow(child, id))] : [header];
}

function fieldRow(candidate: TemplateField, parentGroupId?: string): TemplateFieldRow {
  return {
    id: `field-${candidate.superobject_type_id ?? 'root'}-${candidate.field_uuid}`,
    field: candidate, isGroup: false, expanded: false, parentGroupId
  };
}
